"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APISetUserGoalRequestSchema = void 0;
const zod_1 = require("zod");
exports.APISetUserGoalRequestSchema = zod_1.z.object({
    goalIds: zod_1.z.array(zod_1.z.number()).min(1).max(3),
});
//# sourceMappingURL=user_goal.js.map